export enum PressureAnalysisSetTypeEnum {
    Overread = "LAS_OVERREAD",
    QC = "LAS_QC",
    Site = "LAS_SITE",
}